/**
 * Billing display utilities.
 *
 * Classification and proration calculations are handled by the backend
 * via /billing/plan-options API. This file retains display helpers only.
 */

const TIER_ORDER = { STARTER: 0, BASIC: 1, PRO: 2, PRO_2X: 3, PRO_4X: 4, PRO_8X: 5, NITRO: 6, NITRO_2X: 7 };

const TIER_DISPLAY_NAMES = {
  STARTER: 'Starter',
  BASIC: 'Basic',
  PRO: 'Pro',
  PRO_2X: '2x Pro',
  PRO_4X: '4x Pro',
  PRO_8X: '8x Pro',
  NITRO: 'Nitro',
  NITRO_2X: '2x Nitro',
};

/**
 * Plan families for slider layout.
 * Groups tiers into logical families — each family becomes one card in slider mode.
 * Order of families and tiers within families matches display_order from backend.
 */
const PLAN_FAMILIES = [
  { key: 'STARTER', label: 'Starter', icon: '/icons/plan_starter.svg', tiers: ['STARTER'], hasSlider: false },
  { key: 'BASIC', label: 'Basic', icon: '/icons/plan_basic.svg', tiers: ['BASIC'], hasSlider: false },
  { key: 'PRO', label: 'Pro', icon: '/icons/plan_pro.svg', tiers: ['PRO', 'PRO_2X', 'PRO_4X', 'PRO_8X'], hasSlider: true, isPopular: true },
  { key: 'NITRO', label: 'Nitro', icon: '/icons/plan_nitro.svg', tiers: ['NITRO', 'NITRO_2X'], hasSlider: true },
];

/**
 * Group flat plans array into families for slider layout.
 * @param {Array} plans - Flat array of plan objects from backend
 * @returns {Array} Array of family objects with their resolved plans
 */
const groupPlansByFamily = (plans) => {
  return PLAN_FAMILIES.map((family) => {
    const familyPlans = family.tiers
      .map((tier) => plans.find((p) => p.tier === tier))
      .filter(Boolean);
    return {
      ...family,
      plans: familyPlans,
    };
  }).filter((family) => family.plans.length > 0);
};

export { TIER_ORDER, TIER_DISPLAY_NAMES, PLAN_FAMILIES, groupPlansByFamily };
